//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import { useEffect, useState } from 'react';

const useZoom = (threshold = 300) => {
  const [isZoomedIn, setIsZoomedIn] = useState(false);

  useEffect(() => {
    const handleZoomChange = () => {
      const zoomLevel = (window.outerWidth / window.innerWidth) * 100;
      setIsZoomedIn(zoomLevel >= threshold);
    };

    handleZoomChange();

    window.addEventListener('resize', handleZoomChange);

    return () => {
      window.removeEventListener('resize', handleZoomChange);
    };
  }, [threshold]);

  return isZoomedIn;
};

export default useZoom;
